class ConfiguratorRepository {

  calculateConfigurator(configurator) {
    return fetch('/configurator/api/v1/' + 'configuratorConfiguration/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-CSRF-TOKEN': `${window.__globalConfig.csrfToken.value}`,
      },
      body: JSON.stringify(configurator),
    })
  }

  addToCart(configurator) {
    return fetch('/boxmaker/' + 'addToBasket/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-CSRF-TOKEN': `${window.__globalConfig.csrfToken.value}`,
      },
      body: JSON.stringify(configurator),
    })
  }

}

export default ConfiguratorRepository;
